import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import logo from "../img/Logo-Icontec-CotizApp_WH.png";

const cookie = new Cookies();
export const SidebarDataAdmin = [
  {
    title: "Admin: " + cookie.get("Nombre"),
    path: "/Index",
    icon: <IoIcons.IoIosPerson />,
  },

  {
    title: "Gestión Usuarios",
    path: "/InfoUsuarios",
    icon: <IoIcons.IoIosPeople />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Regional",
    path: "/InfoRegional",
    icon: <IoIcons.IoIosMap />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Solicitudes GENED",
    path: "/InfoSolicitudes/" + cookie.get("correo"),
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },

  {
    title: "Solicitudes Admin",
    path: "/SolicitudAdmin",
    icon: <IoIcons.IoIosCreate />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: (
      <span style={{ fontSize: "13px" }}>
        Solicitudes Cooperación y proyectos especiales
      </span>
    ),
    path: "/InfoEspeciales",
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },

  {
    title: "Clasificación Comercial",
    path: "/InfoClasificacion",
    icon: <IoIcons.IoIosChatboxes />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Modalidad",
    path: "/InfoModalidad",
    icon: <IoIcons.IoIosBookmark />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Modular",
    path: "/InfoModular",
    icon: <IoIcons.IoIosMail />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Estados",
    path: "/InfoEstados",
    icon: <IoIcons.IoIosCheckbox />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },

  {
    title: "Manuales",
    path: isDisabled,
    icon: <AiIcons.AiFillHome />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Manual de Gestor",
        path: "/ManualGestor",
        icon: <IoIcons.IoIosVideocam />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
      },
      {
        title: "Manual comercial",
        path: "/ManualComercial",
        icon: <IoIcons.IoIosVideocam />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
      },
    ],
  },

  {
    title: <CerrarSesion />,
    path: "/",
  },
];
